export default function MIN() {
  return (
    <div className="p-4">
      <h1>MIN</h1>
    </div>
  );
}
